export const testimonials = {
  // SEO
  'seo.title': 'Client Reviews — Success Stories | Sofia and Elena Nutritionists',
  'seo.description': 'Read real reviews from our clients about working with Sofia and Elena. Success stories in child nutrition, hormonal balance restoration, FMD protocol and joint support from two experts.',
  'seo.keywords': 'nutritionist reviews, nutrition results, success stories, child nutrition reviews, FMD protocol results, health restoration',

  // Hero Section
  'hero.title': 'What our clients say',
  'hero.description': 'We don\'t sell results — we sell emotions. Stories of those who fell in love with themselves again.',

  // Testimonial 1
  'testimonial1.category': 'Child Nutrition',
  'testimonial1.name': 'Anna M.',
  'testimonial1.text': 'My child started eating vegetables and stopped getting sick every fall. Sofia is our angel! Every meal used to be a battle, and now my daughter asks for broccoli herself. I didn\'t believe it was possible.',
  'testimonial1.highlight': 'Child started eating vegetables and stopped getting sick',

  // Testimonial 2
  'testimonial2.category': 'Joint Support',
  'testimonial2.name': 'Maria K.',
  'testimonial2.text': 'It was a real consilium! One found the cause in the thyroid, the other taught me to eat deliciously and enjoy the process. I feel 10 years younger. Energy returned, skin glows, and I fell in love with my reflection again.',
  'testimonial2.highlight': 'I feel 10 years younger',

  // Testimonial 3
  'testimonial3.category': 'FMD Protocol',
  'testimonial3.name': 'Ekaterina L.',
  'testimonial3.text': '5 days that replaced a vacation for me. Lightness, clear mind and incredible energy. I didn\'t expect such an effect! I feel how my body renewed from within. This is not a diet — it\'s a reboot of the entire body.',
  'testimonial3.highlight': '5 days that replaced a vacation',

  // Testimonial 4
  'testimonial4.category': 'Child Nutrition',
  'testimonial4.name': 'Olga V.',
  'testimonial4.text': 'My allergic son now eats diversely and with pleasure. Sofia helped us build a nutrition system that works for the whole family. No more rashes and endless restrictions. Thank you for returning to normal life!',
  'testimonial4.highlight': 'No more rashes',

  // Testimonial 5
  'testimonial5.category': 'Joint Support',
  'testimonial5.name': 'Daria S.',
  'testimonial5.text': 'Double expertise is what I needed. While Elena dealt with my GI tract and hormones, Sofia built nutrition so I lost weight but my face didn\'t lose volume. The result exceeded all expectations. I feel like myself again.',
  'testimonial5.highlight': 'I feel like myself again',

  // Testimonial 6
  'testimonial6.category': 'FMD Protocol',
  'testimonial6.name': 'Irina N.',
  'testimonial6.text': 'Biohacking that really works. After the protocol, I forgot about evening fatigue and brain fog. I feel at my peak. This is not just detox — it\'s a scientific approach to rejuvenation at the cellular level.',
  'testimonial6.highlight': 'Forgot about evening fatigue and brain fog',

  // Bottom CTA
  'cta.title': 'Ready to write your success story?',
  'cta.description': 'Join hundreds of clients who have already changed their lives with our help',
  'cta.button': 'Book Free Diagnostic',
};